export default "__VITE_ASSET__DTcj6nC0__"